var _jsxFileName = "/repo/packages/webassets/src/components/ErrorController/index.tsx";
import React from 'react';
import { Query } from '@apollo/client/react/components';
function ErrorController(_ref) {
  var children = _ref.children,
    query = _ref.query,
    context = _ref.context,
    variables = _ref.variables,
    apolloClient = _ref.apolloClient,
    handler = _ref.handler;
  return /*#__PURE__*/React.createElement(Query, {
    query: query,
    context: context,
    variables: variables,
    client: apolloClient,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 5
    }
  }, function (_ref2) {
    var loading = _ref2.loading,
      error = _ref2.error,
      data = _ref2.data;
    return handler(loading, error, data) || children;
  });
}
export default ErrorController;
//# sourceMappingURL=index.js.map